import { Check } from '@mui/icons-material';
import {
    Step,
    StepConnector,
    StepLabel,
    Stepper,
    Typography,
    stepConnectorClasses,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useEffect, useState } from 'react';

import SampleProcessing from '../../assests/images/SampleProcessing.png';
import { formatDate } from '../../utils';
import TrackDetailsView from './TrackingDetailsPopUp'

const CustomStepIcon = props => {
    const { completed, className, status } = props;
    return (
        <div
            className={className}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: 40,
                height: 40,
                justifyContent: 'center',
                borderRadius: '50%',
                border:
                    completed || status === 'In Progress'
                        ? 'none'
                        : '2px solid #707070',
                backgroundColor:
                    completed || status === 'In Progress' ? '#40BB2A' : 'white',
                color: 'white',
            }}>
            {completed ? (
                <Check style={{ fontSize: 16 }} />
            ) : status === 'In Progress' ? (
                <img src={SampleProcessing} alt="logo" />
            ) : null}
        </div>
    );
};

const CustomisedConnectorHorizontal = styled(StepConnector)(({ theme }) => ({
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: '10px',
        marginTop: '7px',
        backgroundColor: '#707070',
    },
}));

const CustomisedConnectorVertical = styled(StepConnector)(({ theme }) => ({
    [`& .${stepConnectorClasses.line}`]: {
        width: 3,
        border: '10px',
        backgroundColor: '#707070',
        position: 'absolute',
        left: '112%',
        bottom: 10,
    },
}));

export default function TrackReportStatusStepper(props) {
    const [trackingData, setTrackingData] = useState([]);
    const [showTrackingDetailsPopUp, setShowTrackingDetailsPopUp] =
        useState(false);
    const trackingSequence = [
        'Shipped',
        'Lab arrival',
        'Sample processing',
    ];
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    const stepStyle = {
        backgroundColor: '#fff',
        padding: 4,
        '& .Mui-active': {
            '&.MuiStepIcon-root': {
                color: 'primary',
            },
        },
        '& .Mui-completed': {
            '&.MuiStepIcon-root': {
                color: '#40BB2A',
            },
        },
        '&.MuiStepper-root': {
            display: 'flex',
            alignItems: isSmallScreen ? 'center' : 'flex-start',
        },
    };

    useEffect(() => {
        if (props.tracking_data) {
            let trackingSequenceData = [];
            trackingSequence.forEach(key => {
                props.tracking_data?.forEach(trackData => {
                    if (key === trackData.status_name) {
                        trackingSequenceData.push(trackData);
                    }
                });
            });
            setTrackingData(trackingSequenceData);
        }
    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Box color="white" mb={2}>
            {showTrackingDetailsPopUp && (
                <TrackDetailsView
                    showTrackingDetailsPopUp={showTrackingDetailsPopUp}
                    setShowTrackingDetailsPopUp={setShowTrackingDetailsPopUp}
                    tracking_no={props.tracking_no ? props.tracking_no : ''}
                />
            )}
            {trackingData && (
                <Stepper
                    alternativeLabel
                    orientation={isSmallScreen ? 'vertical' : 'horizontal'}
                    sx={stepStyle}
                    connector={
                        isSmallScreen ? (
                            <CustomisedConnectorVertical />
                        ) : (
                            <CustomisedConnectorHorizontal />
                        )
                    }>
                    {trackingData.map(trackData => (
                        <Step
                            sx={{
                                width: '200px',
                                marginTop: '10px',
                                marginBottom: '10px',
                            }}
                            key={trackData.status_name}
                            completed={
                                trackData?.status === 'Done' ? true : false
                            }>
                            <StepLabel
                                StepIconComponent={Stepprops => (
                                    <CustomStepIcon
                                        {...Stepprops}
                                        status={trackData.status}
                                    />
                                )}>
                                <Typography variant="subtitle2">
                                    <b>{trackData.status_name}</b>
                                </Typography>
                                <Typography variant="body2">
                                    {trackData.status !==
                                        'Sample processing' && trackData.status_name !== 'Lab arrival'
                                        ? trackData.event_date
                                            ? formatDate(trackData.event_date)
                                            : ''
                                        : ''}

                                    {trackData.status_name === 'Lab arrival' &&
                                        trackData.status === 'Done' && (
                                            <div style={isSmallScreen ? { width: '250px' } : {}}>
                                                <p style={{ margin: 0 }}>
                                                    <b>Kit arrived at lab -</b>{' '}
                                                    {trackData.event_date ? formatDate(trackData.event_date) : 'not available'}
                                                </p>
                                                <p style={{ margin: 0 }}>
                                                    <b>Kit received by lab -</b>{' '}
                                                    {props?.kit_received_date ? formatDate(props.kit_received_date) : 'not available'}
                                                </p>
                                            </div>
                                        )}
                                </Typography>
                                {trackData.status_name === 'Shipped' &&
                                    trackData.status === 'Done' &&
                                    props?.tracking_no && (
                                        <span
                                            style={{ color: 'blue' }}
                                            className="table-action-icon"
                                            onClick={() =>
                                                setShowTrackingDetailsPopUp(
                                                    true,
                                                )
                                            }
                                            color="blue">
                                            View Details
                                        </span>
                                    )}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
            )}
        </Box>
    );
}
